function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Menu, MenuButton, MenuItem, MenuSeparator, useMenuState } from 'reakit/Menu';
import { buildClassNames } from '../../../modules/css-helpers';
import { addVariant, hasVariant } from '../../../modules/variant-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpBox } from '../../containers/box/component';
import { OwnUpIcon } from '../../images/icons';
import { getOptionValue, OwnUpOptionBreak } from '../../properties';
import { OwnUpDropDownBreakStyle, OwnUpDropDownChevronStyle, OwnUpDropDownInputStyle, OwnUpDropDownItemStyle, OwnUpDropDownMenuWrapperStyle, OwnUpDropDownWrapperStyle } from './style';
/**
 * Drop Down component properties.
 */

var StyledDropDownInput = createOwnUpComponent(MenuButton, OwnUpDropDownInputStyle);

var OwnUpDropDownInput = function OwnUpDropDownInput(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var builtClass = buildClassNames('ou-drop-down__input', className);
  return /*#__PURE__*/React.createElement(StyledDropDownInput, _extends({
    type: "button",
    className: builtClass
  }, props));
};

var StyledDropDownMenu = createOwnUpComponent(Menu, OwnUpDropDownWrapperStyle);

var OwnUpDropDownMenu = function OwnUpDropDownMenu(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  var builtClass = buildClassNames('ou-drop-down__menu', className);
  return /*#__PURE__*/React.createElement(StyledDropDownMenu, _extends({
    className: builtClass
  }, props));
};

var StyledDropdDownMenuWrapper = createOwnUpComponent('div', OwnUpDropDownMenuWrapperStyle);

var OwnUpDropDownMenuWrapper = function OwnUpDropDownMenuWrapper(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["className"]);

  var builtClass = buildClassNames('ou-drop-down__menu-wrapper', className);
  return /*#__PURE__*/React.createElement(StyledDropdDownMenuWrapper, _extends({
    className: builtClass
  }, props));
};

var StyledDropDownItem = createOwnUpComponent(MenuItem, OwnUpDropDownItemStyle);

var OwnUpDropDownItem = function OwnUpDropDownItem(_ref4) {
  var className = _ref4.className,
      props = _objectWithoutProperties(_ref4, ["className"]);

  var builtClass = buildClassNames('ou-drop-down__item', className);
  return /*#__PURE__*/React.createElement(StyledDropDownItem, _extends({
    type: "button",
    className: builtClass
  }, props));
};

var StyledDropDownBreak = createOwnUpComponent(MenuSeparator, OwnUpDropDownBreakStyle);

var OwnUpDropDownBreak = function OwnUpDropDownBreak(_ref5) {
  var className = _ref5.className,
      props = _objectWithoutProperties(_ref5, ["className"]);

  var builtClass = buildClassNames('ou-drop-down__break', className);
  return /*#__PURE__*/React.createElement(StyledDropDownBreak, _extends({
    className: builtClass
  }, props));
};

var StyledDropDownChevron = createOwnUpComponent(OwnUpIcon, OwnUpDropDownChevronStyle);

var OwnUpDropDownChevron = function OwnUpDropDownChevron(_ref6) {
  var className = _ref6.className,
      props = _objectWithoutProperties(_ref6, ["className"]);

  var builtClass = buildClassNames('ou-drop-down__chevron', className);
  return /*#__PURE__*/React.createElement(StyledDropDownChevron, _extends({
    className: builtClass,
    icon: "AdvisorChevronDown"
  }, props));
};
/**
 * Custom wrapper around Reakit's Menu Value state.
 *
 * Used to unwrap the default value and invoke onChange listeners.
 */
// Note: due to parser limitations, generic function args in TSX
//   files cannot use arrows.


function useOwnUpDropDownState(_ref7) {
  var onChange = _ref7.onChange,
      value = _ref7.value;
  // Initialize the base state.
  var state = getOptionValue(value); // Return a custom implementation of the "setState" function which
  //   calls the onChange functionality with the current state and
  //   "incoming" state.

  return {
    state: state,
    setState: function setState(action) {
      var currentState = state.value; // Invoke the action to fetch the new value.

      var newValue = typeof action === 'function' ? action(currentState) : action; // Call the handler with the new value and the current value.

      onChange(newValue, currentState);
    }
  };
}
/**
 * A collection of options in which a user may select one.
 *
 * @param props - see {@link OwnUpDropDownProperties}
 */
// Note: due to parser limitations, generic function args in TSX
//   files cannot use arrows.


export function OwnUpDropDown(_ref8) {
  var name = _ref8.name,
      value = _ref8.value,
      options = _ref8.options,
      className = _ref8.className,
      variant = _ref8.variant,
      onChange = _ref8.onChange,
      disabled = _ref8.disabled,
      placeholder = _ref8.placeholder,
      props = _objectWithoutProperties(_ref8, ["name", "value", "options", "className", "variant", "onChange", "disabled", "placeholder"]);

  var menuState = useMenuState();
  var dropDownState = useOwnUpDropDownState({
    value: value,
    onChange: onChange
  });
  var miniProps = {
    className: className,
    variant: variant
  };

  if (placeholder === undefined) {
    placeholder = variant === 'onboarding' ? undefined : ' - - - ';
  }

  var dropDownOptions = options.map(function (option, index) {
    var key = "dd-".concat(index);

    if (option === OwnUpOptionBreak) {
      return /*#__PURE__*/React.createElement(OwnUpDropDownBreak, _extends({
        key: key
      }, miniProps));
    }

    var val = getOptionValue(option);
    var myProps = {
      className: "".concat(className || '', " ").concat(val.className || ''),
      variant: addVariant(variant, val.variant)
    };
    return /*#__PURE__*/React.createElement(OwnUpDropDownItem, _extends({}, myProps, {
      key: key,
      onClick: function onClick() {
        dropDownState.setState(val.value);
        menuState.toggle();
      }
    }), /*#__PURE__*/React.createElement(OwnUpBox, null, val.display));
  });
  var buttonDisplay;
  var ariaLabel = placeholder && typeof placeholder === 'string' ? placeholder : name;
  var inputProps;
  var inputOptionIndex = options.findIndex(function (o) {
    return getOptionValue(o).value === value;
  });

  if (inputOptionIndex > -1) {
    var inputValue = getOptionValue(options[inputOptionIndex]);
    ariaLabel = undefined; // Let the browser decide

    buttonDisplay = inputValue.display;
    inputProps = {
      className: "".concat(className || '', " ").concat(inputValue.className || ''),
      variant: addVariant(variant, inputValue.variant)
    };
  } else {
    buttonDisplay = placeholder;
    inputProps = miniProps;
  }

  var dropDownOffset = hasVariant(inputProps.variant, 'onboarding') ? {
    transform: "translate(0,0)"
  } : {
    transform: "translate(0px, ".concat(-38 * (inputOptionIndex + 1) + inputOptionIndex, "px)")
  }; // 38, 77, 112

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OwnUpDropDownInput, _extends({}, menuState, {
    disabled: disabled
  }, inputProps, props, {
    "aria-label": ariaLabel
  }), /*#__PURE__*/React.createElement(OwnUpBox, null, buttonDisplay), /*#__PURE__*/React.createElement(OwnUpDropDownChevron, miniProps)), /*#__PURE__*/React.createElement(OwnUpDropDownMenuWrapper, miniProps, /*#__PURE__*/React.createElement(OwnUpDropDownMenu, _extends({
    "aria-label": ariaLabel
  }, menuState, miniProps, {
    style: dropDownOffset
  }), dropDownOptions)));
}